import { QueryClientProvider } from '@tanstack/react-query';
import '../styles/globals.css';
import './lib/custom-fields';
import { queryClient } from './lib/query-client';
import { AppProvider } from './providers/app.provider';
import { ThemeProvider } from './providers/theme/theme.provider';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AppProvider />
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
